import React from 'react';
import SkeletonComponent from './SkeletonComponent';

const InputSkeleton = ({ className, fontSize = 16, hideLabel = false }) => {
  return (
    <div className={className || ''}>
      {!hideLabel && <label style={{ fontSize }}>
        <SkeletonComponent width={120} height={fontSize} />
      </label>}
      <SkeletonComponent className="form-control" />
    </div>
  );
};

export default InputSkeleton;
